import { render } from "./Invite.vue?vue&type=template&id=0b557457&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"

import "./Invite.vue?vue&type=style&index=0&id=0b557457&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b557457"]])

export default __exports__